// extracted by mini-css-extract-plugin
export default {"select":"SelectModel-module__select--c90c3"};